export const FETCH_GEO_DATA_REQUEST = 'FETCH_GEO_DATA_REQUEST';
export const FETCH_GEO_DATA_SUCCESS = 'FETCH_GEO_DATA_SUCCESS';
export const FETCH_GEO_DATA_FAILURE = 'FETCH_GEO_DATA_FAILURE';
